// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".open-question{background:#fcfcfc}.open-question .el-dialog__body{padding:.417vw 1.042vw}.open-question .el-icon-close{display:none}", ""]);
// Exports
module.exports = exports;
